module.exports = __webpack_public_path__ + "assets/1-sales-director-job-information.dabb0aea.png";